<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Partnerzy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group >
  <mat-tab label="Dane">
<!--    <app-licensed-details-view *ngIf="!modify" (modifyClicked)="modify = true" [licensed]="licensed"  (licensedChanged)="loadLicensed()" >-->
<!--    </app-licensed-details-view>-->
<!--    <app-licensed-details-form *ngIf="modify" [licensedObject]="licensedObject" (closeModification)="modify = false; loadLicensed()"></app-licensed-details-form>-->
<app-affiliate-code-details-view  (modifyClicked)="loadAffiliateCode()" [affiliateCode]="affiliateCode" > </app-affiliate-code-details-view>
  </mat-tab>x
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list  [affiliateCode]="affiliateCode"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
